import {
  IPrintPlan,
  ModalInkPlansAnalyticsEvent,
  ModalInkPlansAnalyticsPayload,
} from '../types';
import { ButtonsContainer, Container, PlanButton, Title } from './styles';

interface PrintPlansOptionsProps {
  title: string;
  printPlans: IPrintPlan[];
  selectedModelPurpose: string;
  setSelectedModelPurpose: (modelPurpose: string) => void;
  onAnalytics?: (data: ModalInkPlansAnalyticsPayload) => void;
}

export const PrintPlansOptions = ({
  title,
  printPlans,
  selectedModelPurpose,
  setSelectedModelPurpose,
  onAnalytics,
}: PrintPlansOptionsProps) => {
  const handlePlanSelect = (planModelPurpose: string) => {
    setSelectedModelPurpose(planModelPurpose);

    if (onAnalytics) {
      onAnalytics({
        eventName: ModalInkPlansAnalyticsEvent.PLAN_SELECTED,
        payload: {
          planModelPurpose,
        },
      });
    }
  };

  return (
    <Container>
      <Title>{title}</Title>

      <ButtonsContainer>
        {printPlans.map((plan) => (
          <PlanButton
            id={`${plan.planModelPurpose}-plan-button`}
            key={plan.planModelPurpose}
            onClick={() => handlePlanSelect(plan.planModelPurpose)}
            selected={selectedModelPurpose === plan.planModelPurpose}
          >
            {plan.planModelPurpose}
          </PlanButton>
        ))}
      </ButtonsContainer>
    </Container>
  );
};
